// components/AIChat/ChatMessage.jsx
import React from "react";
import { FiUser, FiCopy } from "react-icons/fi";
import { HiOutlineSparkles } from "react-icons/hi";
import "./AIChat.css";

export default function ChatMessage({ sender, text }) {
  const isBot = sender === "bot";

  const copyText = () => {
    navigator.clipboard.writeText(text);
  };

  return (
    <div className={`chat-msg ${isBot ? "bot" : "user"}`}>
      {isBot && (
        <div className="chat-avatar bot">
          <HiOutlineSparkles size={18} />
        </div>
      )}

      <div className="msg-wrapper">
        <div className="msg-text">{text}</div>

        <button className="copy-btn" onClick={copyText} title="Copy">
          <FiCopy size={14} />
        </button>
      </div>

      {!isBot && (
        <div className="chat-avatar user">
          <FiUser size={16} />
        </div>
      )}
    </div>
  );
}
  